import React from "react";

const FleetOverviewCard = ({ fleetRisk = 78, highRisk = 1, openItems = 8, repairExposure = "$370K" }) => (
  <div className="frm-card">
    <div className="risk-overview">
      <div className="risk-donut-col">
        <svg width="96" height="96" viewBox="0 0 96 96">
          <circle cx="48" cy="48" r="38" fill="none" stroke="#e2e4e8" strokeWidth="9"/>
          <circle cx="48" cy="48" r="38" fill="none" stroke="#1a9e78" strokeWidth="9"
            strokeDasharray="178 60" strokeDashoffset="-15" strokeLinecap="round"/>
          <text x="48" y="46" textAnchor="middle" fontSize="22" fontWeight="500" fill="#1a1e2e">{fleetRisk}</text>
          <text x="48" y="60" textAnchor="middle" fontSize="10" fill="#8a909e">Fleet Risk</text>
        </svg>
        <span className="risk-badge">Elevated Attention</span>
      </div>
      <div className="risk-content-col">
        <p>
          Move from isolated fuel saving initiatives to a machinery-aware, berth-aware, and
          weather-aware operating system that continuously chooses the best voyage plan, speed
          envelope, equipment loading pattern, and maintenance window.
        </p>
        <div className="risk-stats-row">
          <div>
            <div className="rst-label">High risk vessels</div>
            <div className="rst-value">{highRisk}</div>
            <div className="rst-note">Flora Schulte is driving most of the fleet risk</div>
          </div>
          <div>
            <div className="rst-label">Open risk items</div>
            <div className="rst-value amber">{openItems}</div>
            <div className="rst-note">6 items need quick engineering follow-up</div>
          </div>
          <div>
            <div className="rst-label">Repair exposure</div>
            <div className="rst-value teal">{repairExposure}</div>
            <div className="rst-note">Current cost exposure across the sister fleet</div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
export default FleetOverviewCard;